module.exports = __webpack_public_path__ + "static/media/pf.7da48bf5.svg";